import { ColorSelect } from 'server/selects'

export function getLandingColorVariables({ colors }: { colors: NonNullable<ColorSelect>[] }) {
  return colors.reduce<string>((variables, color, index) => {
    variables += `--color-${color.name}: ${color.value};
  `
    return variables
  }, '')
}
